// function matchDivHeight(divToMatch, divToResize) {
//   // Function to adjust the height based on window width
//   function adjustHeight() {
//     // Check if the window width is greater than 750px (desktop)
//     if (window.innerWidth > 750) {
//       // Get the height of the div to match
//       const matchHeight = divToMatch.offsetHeight; 
      
//       // Set the height of the div to resize
//       divToResize.style.width = matchHeight + 'px';
//     } else {
//       // Reset the height for smaller screens
//       divToResize.style.width = 'auto';
//     }
//   }

//   // Call the function initially to set the height
//   adjustHeight();

//   // Attach resize event to adjust height dynamically
//   window.addEventListener('resize', adjustHeight);
// }

// // Example usage
// const div1 = document.querySelector('.Gallery_main-image slider-component'); // Div to match
// const div2 = document.querySelector('.Gallery_thumbnail-image slider-component'); // Div to resize



// // Match div2's height to div1's height on window resize, but only for desktop (width > 750px)
// matchDivHeight(div1, div2);

// $(document).on("click", ".Gallery_thumbnail-image .thumbnail", function(){
//    matchDivHeight(div1, div2);
// })

(function() {
  var featuredPopout = function() {
    $(document).on('click','.info-popout_grid_box-overlay__btn',function(e){
      $(this).hide();
      $(this).parent().find('.info-popout_grid_box-overlay__txt').fadeIn();
    });
    $(document).on('click','.info-popout_grid_box-overlay__txt h3 span',function(e){
      $(this).parents('.info-popout_grid_box-overlay__txt').hide();
      $(this).parents('.info-popout_grid_box-overlay').find('.info-popout_grid_box-overlay__btn').fadeIn();
    });
  };
  var featuredColumnSlider = function() {
     $('.column-slider_wrap').flickity({
      // options
      cellAlign: 'left', 
      wrapAround: true

    }); 
  };
  var featuredColSlider = function() {
     $('.featured-col-slider').flickity({
      // options
      cellAlign: 'left', 
      wrapAround: true

    }); 
  };
  var featuredLinks = function() {
     $('.featured-links__box').readmore({ 
       speed: 75, 
       collapsedHeight: 165,
       moreLink: '<a href="#">and more...</a>',
       lessLink: '<a href="#">less</a>' 
     });
  };
  var featuredVideos= function() {
     $('.column-videos__box').flickity({
      // options
       cellAlign: 'center',
       wrapAround: true,
       prevNextButtons: false,
       pageDots: false,
       imagesLoaded: true,

    }); 
    $('.prod_column-videos__box').flickity({
      // options
       cellAlign: 'left',
       wrapAround: true,
       prevNextButtons: true,
       pageDots: false,
       imagesLoaded: true,
      groupCells: true
      
    });
  };
  var featuredReviewsSlider = function() {
    $('.featured-reviews-slider').flickity({
      // options
      cellAlign: 'left',
      wrapAround: true,
      pageDots: true,
      prevNextButtons: true, 
      groupCells: true
    });
  };
  var featuredFeedsSlider = function() {
    $('.featured-feeds__slider').flickity({
      // options
      cellAlign: 'left',
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true, 
      groupCells: true,
      imagesLoaded: true

    });
    // Default state
  if ( matchMedia('screen and (max-width: 749px)').matches ) {

    $('.featured-feeds__slider').flickity({
      cellAlign: 'center'
    });

  }

  // // Change when larger screen is loaded
  if ( matchMedia('screen and (min-width: 750px)').matches ) {

    $('.featured-feeds__slider').flickity({
      cellAlign: 'left'
    });

  }
  };
  featuredPopout();
  featuredColumnSlider();
  featuredColSlider();
  featuredLinks();
  featuredVideos();
  featuredReviewsSlider();
  featuredFeedsSlider();

  $(document).on('shopify:section:load', function(event) { 
    featuredPopout();
    featuredColumnSlider();
    featuredColSlider();
    featuredLinks();
    featuredVideos();
    featuredReviewsSlider();
    featuredFeedsSlider();
  });
}());
